import React from 'react';
import '../styles/Footer.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-brand">
          <h2>ISPATEC<span className="dot">.</span></h2>
          <p>Votre passerelle vers les opportunités éducatives et les partenariats d'influence.</p>
        </div>

        {/* LINKS */}
        <div className="footer-links">
          <h4>Liens utiles</h4>
          <ul>
            <li><a href="#accueil">Accueil</a></li>
            <li><a href="#how">Comment ça marche</a></li>
            <li><a href="#demande">Inscription</a></li>
            <li><a href="#cibles">Influenceurs</a></li>
            <li><a href="https://www.ispatec.net"target="_blank">Notre site officiel</a></li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-contact">
          <h4>Nous contacter</h4>
          <ul>
            <li><FaMapMarkerAlt className="icon" /> Bamako, Mali </li>
            <li><FaPhoneAlt className="icon" /> (+223) 77-76-11-12</li>
            <li><FaEnvelope className="icon" />isatec.ml@gmail.com</li>
          </ul>
        </div>
 

        {/* SOCIAL */}
        <div className="footer-social">
          <h4>Suivez-nous</h4>
          <div className="social-icons">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaYoutube /></a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} ISPATEC. Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;
